import FooterSetup from '@/features/design-system/components/common/FooterSetup'
import { DATA_PAGINATION, EtZone } from '@/types'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import useTranslation from '@/hooks/useTranslation'

interface EtZoneTableProps {
  data?: DATA_PAGINATION<EtZone>
}

const EtZoneTable: FC<EtZoneTableProps> = ({ data }) => {
  const { t } = useTranslation()

  return (
    <Stack flexGrow="1" justifyContent="space-between">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  width: '182px',
                  position: 'sticky',
                  left: 0,
                  borderRight: '1px solid #D7D7D7',
                }}
              >
                { t('formsLabelsMicroClimate') }
              </TableCell>
              <TableCell
                sx={{
                  width: '562.5px',
                }}
              >
                { t('mapView.content.soilMoistureSensor') }
              </TableCell>
              <TableCell
                sx={{
                  width: '562.5px',
                }}
              >
                { t('mapViewLayerWeatherStation') }
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ position: 'sticky', left: 0 }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row?.name}
                </TableCell>
                <TableCell>{row?.soidSensor?.name}</TableCell>
                <TableCell
                  sx={{
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  {row?.soidSensor?.thirdPartyStationName}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack>
        <FooterSetup
          title={`${data?.totalCount || 0} rows of data detected`}
          subtitle="Review the data before proceeding"
        />
      </Stack>
    </Stack>
  )
}

export default EtZoneTable
